import { useState } from 'react';
import Icon from 'jsx/components/core/icons/Icon';
import FormInput from './FormInput';

const GenericCell = (props) => {
  const {
    caption,
    header,
    row,
    handleCellSave
  } = props;

  const [showControl, setShowControl] = useState(false);
  const [value, setValue] = useState(row[header?.control?.name]);

  const onClick = () => {
    if (header.control) {
      if (header.control.type === 'checkbox') {
        header.control.value = !row[header.control.name];
        handleCellSave(row.id, header.control);

        return;
      }

      header.control.value = row[header.control.name];
      setValue(row[header.control.name]);
      setShowControl((prevState) => !prevState);
    }
  };

  const onSave = async (controlValue) => {
    header.control.value = controlValue || value || null;

    await handleCellSave(row.id, header.control);

    setShowControl((prevState) => !prevState);
  };

  const onChange = async (event) => {
    await setValue(event.target.value);

    if (header.control.type === 'select' ) {
      onSave(event.target.value);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === 'Enter') onSave(null);
    if (event.key === 'Escape') onClick();
  };

  const renderControl = () => {
    header.control.value = value;

    switch (header.control.type) {
      case 'date':
      case 'select': {
        return (
          <div className="d-flex">
            <FormInput
              handleChange={onChange}
              handleKeyDown={onKeyDown}
              control={header.control}
              hideCaption
              bsSize="sm"
              autoFocus
            />
            {header.control.type === 'date' && (
              <Icon size="1x" name="check" className="mt-2 ml-2 text-success" title="Save" onClick={() => onSave(null)} />
            )}
            <Icon size="1x" name="x-mark" className="mt-2 ml-3 text-danger" title="Cancel" onClick={onClick} />
          </div>
        );
      }
      default: {
        return (
          <div className="d-flex">
            <div className="w-100">
              <FormInput
                handleChange={onChange}
                handleKeyDown={onKeyDown}
                control={header.control}
                hideCaption
                bsSize="sm"
                autoFocus
              />
            </div>
            <Icon size="1x" name="check" className="mt-2 ml-2 text-success" title="Save" onClick={() => onSave(null)} />
            <Icon size="1x" name="x-mark" className="mt-2 ml-3 text-danger" title="Cancel" onClick={onClick} />
          </div>
        );
      }
    }
  };

  return (
    <>
      {!showControl && (<div className="w-100" onClick={onClick}>{caption || '-'}</div>)}

      {showControl && (
        <>{renderControl()}</>
      )}
    </>
  );
};

export default GenericCell;
